module.exports = __webpack_public_path__ + "img/medal_vip1.eff41bc.png";